<template>
    <div>
        <share-project-document ref="ShareProjectDocumentModal" :project="project" :external-email-service="externalEmailService"></share-project-document>
        <div id="webix-box">
            <flash-message></flash-message>

            <div class="text-followup-nav mb-5">
                <div v-if="project" class="text-2xl text-grey-darkest mb-4">Project Resources for
                    {{ projectName ? projectName : '' }}
                </div>
                <div v-else class="text-2xl text-grey-darkest mb-4">Resources</div>
                <div
                    class="flex justify-between items-center text-teal hover:text-teal-dark font-base text-xs mb-4 frozen-form-button">
                    <div v-if="this.project" class="text-teal hover:text-teal-dark font-base text-sm mb-4">
                        <div @click="goBack" class="flex cursor-pointer">
                            <span class="material-icons">chevron_left</span>
                            <span>Back</span>
                        </div>
                    </div>
                    <button type="button" @click.prevent="uploadPhotos" v-if="hasCompanyCamAccess && hasCompanyCamAccessToken && canEdit && companyCamProjectId && companyCamProjectDirectLink"
                            class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline">
                        <i v-if="companyCamSyncLoading" class="fa fa-spin fa-spinner text-grey-darkest"
                           aria-hidden="true"></i>
                        Sync Photos to Company Cam
                    </button>

                    <button type="button" v-if="canEdit" @click="openShareModal()"
                            class="py-2 px-3 mr-1 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none hidden lg:inline">
                        Share Project Documents
                    </button>
                </div>

            </div>
            <div>
                <div v-if="stack" @click.stop.prevent="uploadToStack()" class="pointer hover:bg-grey-lighter mx-1 change_text_color">
                    Upload to STACK <i class="fa fa-upload pl-2"></i>
                </div>
            </div>
            <div id="box" style="height:500px;"></div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import ShareProjectDocument from "../shared/share-project-document.vue";
export default {
    name: "resource-files-webix",
    components: {},
    props: ['team_id', 'user_id', 'canDeleteFolders', 'project', 'projectName', 'url', 'stack', 'clean', 'isPm','companyCamProjectId','companyCamProjectDirectLink','canEdit','hasCompanyCamAccess','hasCompanyCamAccessToken','externalEmailService',
            'canViewDocuments', 'canEditDocuments', 'canDeleteDocuments'],

    data() {
        return {
            csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            companyCamSyncLoading:false,
            fileFolderCount: [],
            folders: []
        };
    },

    created() {
        this.getUrl();
        this.fileManager();
        this.getProjectContacts();
    },

    methods: {
        customRefresh() {
            document.getElementById('box').innerHTML = '';
            document.getElementById('webix-box').innerHTML = '<div id="box" style="height:500px;"></div>';
        },
        getProjectContacts(){
            const self = this;
            axios.post(route('api.resource-files.project-contact'),{
                project_id: self.project,

            }).then((res) =>{
                self.$refs.ShareProjectDocumentModal.projectContacts(res.data.contacts);
            }).catch((err)=>{
                console.log('err',err)
            })
        },
        getUrl() {
            let self = this;
            return self.url+'/api/webix/file-manager/' + (self.project ? self.project : 0) + '/';
        },
        fileManager() {
            const self = this;
            webix.ready(function() {
                if (webix.env.mobile) webix.ui.fullScreen();
                webix.CustomScroll.init();
                class MyBackend extends fileManager.services.Backend {
                    folders(id) {
                        let payload = {id};
                        return webix.ajax(self.getUrl() + 'folders', payload).then(res => {
                          self.folders = res.json();
                          return res.json()
                        });
                    }
                    makedir(id, name) {
                        if(self.canEditDocuments || self.canDeleteDocuments) {
                            let payload = {
                                id,
                                name,
                                _token: self.csrfToken
                            };
                            return webix.ajax().post(self.getUrl() + 'makedir', payload).then((res) => {
                                return res.json();
                            });
                        }
                        else {
                            return new Promise((resolve, reject) => {
                                self.getToast().fire({
                                    type: 'error',
                                    title: "You don't have permission to create a folder"
                                });

                                reject({ success: false, message: "You don't have permission to create a folder" });
                            });
                        }
                    }
                    async remove(id, items) {
                        if(self.canDeleteDocuments) {
                            await webix.ajax(self.getUrl() + 'folders', {id:'/'}).then(res => {
                                self.folders = res.json();
                            });
                            let totalFolders = 0;
                            let totalFiles = 0;

                            for (let item of items) {
                                if (item.type === 'folder') {
                                    const counts = self.getFolderCountsById(item.id);
                                    if (counts) {
                                        totalFolders += counts.folders;
                                        totalFiles += counts.files;
                                    }
                                } else {
                                    totalFiles++;
                                }
                            }

                            return new Promise((resolve, reject) => {

                                let message = '';

                                if (totalFolders > 0 && totalFiles > 0) {
                                    message = `${totalFolders} folder(s) and ${totalFiles} file(s) will be deleted.`;
                                } else if (totalFolders > 0) {
                                    message = `${totalFolders} folder(s) will be deleted.`;
                                } else if (totalFiles > 0) {
                                    message = `${totalFiles} file(s) will be deleted.`;
                                }


                                Swal.fire({
                                    title: message,
                                    html: 'Records can\'t be retrieved once deleted',
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: '#01B1AF',
                                    confirmButtonText: 'Yes, delete it!'
                                }).then((result) => {
                                    if (result.value) {
                                        webix.ajax().post(self.getUrl() + 'delete', {
                                            items,
                                            _token: self.csrfToken
                                        }).then((res) => {
                                            resolve(res.json());
                                        }).catch((error) => {
                                            reject(error); //
                                        });
                                    } else {
                                        resolve({ success: false, message: 'Deletion cancelled' });
                                    }
                                }).catch((error) => {
                                    reject({ success: false, message: 'Error with confirmation dialog' });
                                });
                            });
                        }
                        else {
                            return new Promise((resolve, reject) => {
                                self.getToast().fire({
                                    type: 'error',
                                    title: "You don't have permission to delete resources"
                                });

                                reject({ success: false, message: "You don't have permission to delete resources" });
                            });
                        }
                    }
                    files(id) {
                        let payload = {id};
                        return webix.ajax(self.getUrl() + 'files', payload)
                                    .then(res => res.json());
                    }
                    directLink(id, path, download) {
                        if(self.canEditDocuments || self.canDeleteDocuments) {
                            if(!download) {
                                window.open(path, '_blank');
                            }
                            else {
                                window.open(self.getUrl() + 'direct?id='+id, '_self');
                            }
                        }
                        else {
                            return new Promise((resolve, reject) => {
                                self.getToast().fire({
                                    type: 'error',
                                    title: "You don't have permission to open or download file"
                                });

                                reject({ success: false, message: "You don't have permission to open or download file" });
                            });
                        }
                    }
                    previewURL(obj, width, height) {
                        if(obj.type == 'document') {
                            return obj.thumbnail;
                        }
                        else {
                            return obj.path;
                        }
                    }
                    search(id, search) {
                        let payload = {
                            id,
                            search
                        };
                        return webix.ajax(self.getUrl() + 'files', payload)
                                    .then(res => res.json());
                    }
                    icon(type, size) {
                        //serve image/jpg for all icons
                        return `https://docs.webix.com/filemanager-backend/icons/${size ||
                        "small"}/image/${type.$ext}.svg`;
                    }
                    rename(id, type, name) {
                        if(self.canEditDocuments || self.canDeleteDocuments) {
                            let payload = {
                                id,
                                type,
                                name,
                                _token: self.csrfToken
                            };
                            return webix.ajax().post(self.getUrl() + 'rename', payload).then((res) => {
                                return res.json();
                            });
                        }
                        else {
                            return new Promise((resolve, reject) => {
                                self.getToast().fire({
                                    type: 'error',
                                    title: "You don't have permission to rename resources"
                                });

                                reject({ success: false, message: "You don't have permission to rename resources" });
                            });
                        }
                    }
                    getInfo() {
                        //
                    }
                }
                webix.ui({
                    view: "filemanager",
                    container:"box",
                    url: self.getUrl(),
                    override: new Map([[fileManager.services.Backend, MyBackend]]),
                });

                webix.attachEvent("onBeforeAjax", function(method, url, details, xhr, headers, formData){
                    const parsedUrl = new URL(url);
                    const segments = parsedUrl.pathname.split("/");
                    const lastSegment = segments.filter(Boolean).pop();

                    if(lastSegment === "upload" && !self.canEditDocuments && !self.canDeleteDocuments) {
                        self.getToast().fire({
                            type: 'error',
                            title: "You don't have permission to upload files & folders"
                        });
                    }
                });
            });
        },

      getNestedCountsIncludingCurrent(folder) {
        const counts = { folders: 1, files: 0 };
        this.countNestedItemsIncludingCurrent(folder, counts);
        return counts;
      },

      countNestedItemsIncludingCurrent(folder, counts) {
        if (folder.resources && folder.resources.length > 0) {
          counts.files += folder.resources.length;
        }

        if (folder.data && folder.data.length > 0) {
          folder.data.forEach(nestedFolder => {
            counts.folders++;
            this.countNestedItemsIncludingCurrent(nestedFolder, counts);
          });
        }
      },

      getFolderCountsById(folderId) {
        const folder = this.findFolderById(this.folders, folderId);
        if (folder) {
          return this.getNestedCountsIncludingCurrent(folder);
        } else {
          console.log("Folder not found");
        }
      },

      findFolderById(folders, folderId) {
        for (let folder of folders) {
          if (folder.id === folderId) {
            return folder;
          }

            if (folder.data && folder.data.length > 0) {
                const nestedFolder = this.findFolderById(folder.data, folderId);
                if (nestedFolder) {
                    return nestedFolder;
                }
            }
        }
        return null;
      },
      goBack() {
            window.location = route(`${this.isPm ? 'project-management.' : ''}project.edit`, {project: this.project});
        },
        async uploadToStack() {
            const self = this;
            await axios.post(route('resource-files.upload-stack'),{
                project_id: this.project,
                // folder_id: this.folder.id
            }).then((res) =>{
                self.flash(res.data.message, res.data.status);
            }).catch((err)=>{
                console.log('err',err)
            })
        },
        uploadPhotos() {
            const self = this;
            const payload = {
                projectId: self.project
            }
            self.companyCamSyncLoading = true;
            axios.post(route('api.company-cam.sync-photos.project'), payload).then(response => {
                self.companyCamSyncLoading = false;
                console.log('response', response)
                Swal.fire({
                    title: 'Success',
                    text: "The project's photos have been scheduled to be synchronized with the company cam. The synchronization will be reflected within a few minutes.",
                    type: 'success',
                    showCancelButton: false,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'OK!',
                    closeOnConfirm: false,
                });
            }).catch(error => {
                Swal.fire({
                    title: 'Error',
                    text: "The synchronization of photos has failed",
                    type: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'OK!',
                    closeOnConfirm: false,
                });
            })
        },
        openShareModal(){
            this.$refs.ShareProjectDocumentModal.openModal();
        }
    },
}
</script>

<style scoped>

</style>
